__turbopack_context__.v({
  "eyebrow": "MultiVendorEcommerceServicesCardSection-module__ak6IhG__eyebrow",
  "heading": "MultiVendorEcommerceServicesCardSection-module__ak6IhG__heading",
  "section": "MultiVendorEcommerceServicesCardSection-module__ak6IhG__section",
  "title": "MultiVendorEcommerceServicesCardSection-module__ak6IhG__title",
});
